// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2GLXY","info":"PatientInfo_info__1haF1"};